import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100vh;
  border: 1px solid green;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
  font-family: 'DM Serif Display', serif;
  font-size: 60px;
  color: #585e80;
  margin: 20px;
  text-align: center;
`;

const Link = styled.a`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  text-transform: uppercase;
  color: #585e80;
  margin: 5px 20px;

  &:hover {
    text-decoration: underline;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Body = () => (
  <Container>
    <Title>nicole sabater</Title>
    <LinkWrapper>
      <Link
        href="https://github.com/nsbtr"
        target="_blank"
        rel="noopener noreferrer">
        github
      </Link>
      <Link
        href="https://linkedin.com/in/nicolesabater"
        target="_blank"
        rel="noopener noreferrer">
        linkedin
      </Link>
    </LinkWrapper>
  </Container>
);

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body.js